__turbopack_context__.v({
  "contentWrpOverflowFix": "styles-module-scss-module__SSPjJW__contentWrpOverflowFix",
  "homePageContainer": "styles-module-scss-module__SSPjJW__homePageContainer",
  "homePageContentHolder": "styles-module-scss-module__SSPjJW__homePageContentHolder",
  "pageContainer": "styles-module-scss-module__SSPjJW__pageContainer",
  "pageContentHolder": "styles-module-scss-module__SSPjJW__pageContentHolder",
  "staticPageContentHolder": "styles-module-scss-module__SSPjJW__staticPageContentHolder",
});
